<ts-page [sidenavConfig]="savedViewsSidebarConfig">
  <app-saved-view-sidebar sidenav [relatedToType]="data.customObject?.name"></app-saved-view-sidebar>
  <router-outlet main></router-outlet>
</ts-page>
